import { call, put } from 'redux-saga/effects'
import firebase from 'firebase/app'
import OperatorReportAction from '../reducers/operatorReportReducer'
import Hasura from '../config/hasura'

export function* getOperatorReport({ startAt, endAt }) {
  try {
    yield put(OperatorReportAction.setOperatorReportLoading(true))

    const ref = firebase.firestore().collection('dashboard_users')
    const snapshot = yield call([ref, ref.get])

    const users = []

    if (snapshot.size > 0) {
      snapshot.forEach(doc => {
        users.push({ ...doc.data(), id: doc.id })
      })
    }

    const query = `
        query {
          orders(where: { created_at: {_gte: "${startAt}", _lte: "${endAt}"}, status: {_eq: "delivered"}}) {
            firebase_key
            accepted_by
            ordering_at
            ordered_at
            ordering_by: ordering_by_operator
            ordered_by: ordered_by_operator
            created_at
            current_operator
            operators
          }
        }
      `

    const { orders } = yield call(Hasura.execute, query)

    if (orders && users) {
      yield put(OperatorReportAction.setOperatorReport(orders, users))
    } else {
      yield put(OperatorReportAction.setOperatorReportLoading(false))
    }
  } catch (error) {
    yield put(OperatorReportAction.setOperatorReportLoading(false))
  }
}



// WEBPACK FOOTER //
// ./src/sagas/operatorReportSaga.js